const HeadingSkeleton = ({ width = "200px", height = "32px" }) => {
    return (
        <div className="skeleton" style={{
            height: height,
            width: width,
            marginBottom: "16px",
            borderRadius: "4px"
        }} />
    );
};

export default HeadingSkeleton;
